<template>
<div>
<transcript/>

</div>
</template>
<script>
import transcript from "../../components/academic/transcript.vue";


export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   transcript
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  },
     mounted() {
    
    
   }
};
</script>

<style>


</style>